import Request from "../Request.js";

const companies = {
  getCompany(id) {
    return Request.get(`/company/api/v1/companies/${id}`);
  },
};

export default companies;
